module.exports = __webpack_public_path__ + "static/media/kakao_talk_icon.8affa4f7.svg";